package one.healthium.base.launcher

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf

val LocalPlatformLauncher = staticCompositionLocalOf<PlatformLauncher> { error("No PlatformLauncher provided") }

@Composable
expect fun createPlatformLauncher(): PlatformLauncher